import React, { useEffect, useState, createElement } from 'react';
import { Calendar, Lock, AlertTriangle, X, MousePointerClick, Download, Mail, MessageCircle } from 'lucide-react';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
declare global {
  interface Window {
    fbq: any;
  }
}
export function ThankYouMPage() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  // Function to get next Tuesday date (for /meta-martes traffic)
  const getNextTuesday = () => {
    const now = new Date();
    // Convert to EST timezone
    const estTime = new Date(now.toLocaleString('en-US', {
      timeZone: 'America/New_York'
    }));
    const currentDay = estTime.getDay(); // 0 = Sunday, 2 = Tuesday
    const currentHour = estTime.getHours();
    let daysUntilTuesday = 0;
    if (currentDay === 2) {
      // It's Tuesday
      if (currentHour >= 19) {
        // After 7pm EST, show next week's Tuesday
        daysUntilTuesday = 7;
      } else {
        // Before 7pm EST, show today
        daysUntilTuesday = 0;
      }
    } else if (currentDay < 2) {
      // Before Tuesday this week (Sunday=0, Monday=1)
      daysUntilTuesday = 2 - currentDay;
    } else {
      // After Tuesday (Wednesday=3, Thursday=4, Friday=5, Saturday=6)
      daysUntilTuesday = 7 - currentDay + 2;
    }
    const nextTuesday = new Date(estTime);
    nextTuesday.setDate(estTime.getDate() + daysUntilTuesday);
    const day = nextTuesday.getDate();
    return day;
  };
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('init', '4285913388317138');
    window.fbq('track', 'PageView');
    // Load Wistia scripts
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
    const embedScript = document.createElement('script');
    embedScript.src = 'https://fast.wistia.com/embed/nrxtdp5ht5.js';
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(embedScript);
    // Add Wistia player styles
    const style = document.createElement('style');
    style.textContent = `
      wistia-player[media-id='nrxtdp5ht5']:not(:defined) { 
        background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/nrxtdp5ht5/swatch'); 
        display: block; 
        filter: blur(5px); 
        padding-top:56.25%; 
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(playerScript);
      document.head.removeChild(embedScript);
      document.head.removeChild(style);
    };
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans" data-id="element-3808">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-3809">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=PageView&noscript=1" alt="" data-id="element-3810" />
      </noscript>

      {/* Cyan Header Banner - Tuesday date */}
      <div className="bg-gradient-to-r from-[#00f7fc] to-[#00d7dc] py-3 md:py-5 px-4" data-id="element-3811">
        <div className="max-w-4xl mx-auto text-center" data-id="element-3812">
          <div className="flex items-center justify-center gap-2 md:gap-3" data-id="element-3813">
            <Calendar className="w-5 h-5 md:w-7 md:h-7 text-black" data-id="element-3814" />
            <h1 className="text-xs sm:text-sm md:text-lg lg:text-xl font-bold whitespace-nowrap text-black tracking-tight" data-id="element-3815">
              Reservada La Fecha: Martes {getNextTuesday()} | 7PM EST (Hora
              Miami)
            </h1>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <main className="max-w-6xl mx-auto px-4 py-6 md:py-10" data-id="element-3816">
        {/* Main Headline */}
        <div className="text-center mb-6 md:mb-10" data-id="element-3817">
          <div className="mb-3" data-id="element-3818">
            <div className="inline-flex items-center gap-2 bg-[#00f7fc]/20 border border-[#00f7fc]/50 rounded-full px-4 py-2 mb-3" data-id="element-3819">
              <Lock className="w-4 h-4 text-[#00f7fc]" data-id="element-3820" />
              <span className="text-sm md:text-base font-semibold text-[#00f7fc]" data-id="element-3821">
                Tu lugar está confirmado
              </span>
            </div>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-3 leading-tight tracking-tight" data-id="element-3822">
            Completa Estos 3 Pasos Importantes
            <br data-id="element-3823" />
            <span className="text-[#00f7fc]" data-id="element-3824">Antes De Que Te Vayas</span>
          </h2>
          <p className="text-base md:text-lg text-gray-100 max-w-2xl mx-auto" data-id="element-3825">
            Para aprovechar al máximo la masterclass
          </p>
          <div className="w-full h-1 bg-gradient-to-r from-transparent via-white to-transparent mt-5" data-id="element-3826"></div>
        </div>

        {/* Video + WhatsApp CTA Side by Side */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 mb-10 md:mb-14" data-id="element-3827">
          {/* Video Section - Left (3 columns) */}
          <div className="lg:col-span-3" data-id="element-3828">
            <div className="w-full overflow-hidden border border-[#00f7fc]" style={{
            boxShadow: `
                0 0 20px rgba(0, 247, 252, 0.6),
                0 0 40px rgba(0, 247, 252, 0.4),
                0 0 60px rgba(0, 247, 252, 0.3),
                0 0 80px rgba(0, 215, 220, 0.2),
                inset 0 0 20px rgba(0, 247, 252, 0.1)
              `
          }} data-id="element-3829">
              <wistia-player media-id="nrxtdp5ht5" aspect="1.7777777777777777" data-id="element-3830"></wistia-player>
            </div>
          </div>

          {/* WhatsApp CTA - Right (2 columns) - PRIORITY #1 */}
          <div className="lg:col-span-2 flex flex-col" data-id="element-3831">
            <div className="bg-gradient-to-br from-[#25D366]/20 to-[#128C7E]/20 border-2 border-[#25D366] rounded-2xl p-5 md:p-6 flex-1 flex flex-col" data-id="element-3832">
              <div className="bg-[#25D366] rounded-full py-2 px-4 text-center mb-4 inline-block" data-id="element-3833">
                <h3 className="text-base md:text-lg font-bold tracking-tight text-white flex items-center justify-center gap-2" data-id="element-3834">
                  <MessageCircle className="w-5 h-5" data-id="element-3835" />
                  Paso #1: Únete Al Grupo
                </h3>
              </div>

              <p className="text-sm md:text-base text-gray-200 mb-4 text-center" data-id="element-3836">
                <span className="font-bold text-[#25D366]" data-id="element-3837">¡IMPORTANTE!</span>{' '}
                Únete ahora al grupo exclusivo de WhatsApp para recibir
                recordatorios y contenido extra.
              </p>

              <a href="https://chat.whatsapp.com/Bt9Hxv3xQbfA0QX5MaAAAL" target="_blank" rel="noopener noreferrer" className="block flex-1 min-h-0" data-id="element-3838">
                <div className="relative group h-full" data-id="element-3839"></div>
              </a>

              <a href="https://chat.whatsapp.com/GDTWSXIrqht4FJw9sIPKI4" target="_blank" rel="noopener noreferrer" className="mt-4 w-full bg-[#25D366] hover:bg-[#128C7E] text-white font-bold py-3 px-6 rounded-full text-center transition-all duration-300 flex items-center justify-center gap-2 shadow-lg hover:shadow-[#25D366]/30" data-id="element-3840">
                <MessageCircle className="w-5 h-5" data-id="element-3841" />
                UNIRME AL GRUPO DE WHATSAPP
              </a>
            </div>
          </div>
        </div>

        {/* Step 2: Exclusive Gift */}
        <div className="mb-6 md:mb-8 max-w-3xl mx-auto" data-id="element-3842">
          <div className="bg-gray-700 rounded-full py-3 md:py-4 px-6 md:px-8 text-center mb-4 md:mb-5 inline-block w-full" data-id="element-3843">
            <h3 className="text-lg md:text-xl font-bold tracking-tight" data-id="element-3844">
              Paso #2: Regalo Exclusivo
            </h3>
          </div>

          <div className="bg-gradient-to-r from-[#00f7fc]/90 to-[#00d7dc]/90 border border-[#00f7fc]/30 rounded-lg p-3 md:p-4 mb-4" data-id="element-3845">
            <div className="flex items-center justify-center gap-2 md:gap-3" data-id="element-3846">
              <Download className="w-4 h-4 md:w-5 md:h-5 text-black" data-id="element-3847" />
              <p className="text-sm md:text-base font-semibold text-black" data-id="element-3848">
                Haz clic en la imagen para descargar la guía
              </p>
            </div>
          </div>

          <div className="mb-5 relative group" data-id="element-3849">
            <a href="https://drive.google.com/file/d/1UwCS-6hTXssQIqMUObPKvMnumSsTNm5u/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="block" data-id="element-3850">
              <div className="absolute -inset-0.5 bg-gradient-to-r from-[#00f7fc]/40 to-[#00d7dc]/40 rounded-lg blur-sm opacity-0 group-hover:opacity-100 transition duration-500" data-id="element-3851"></div>
              <div className="relative" data-id="element-3852">
                <img src="https://cdn.magicpatterns.com/uploads/qGszUSvXKGkMXKzhkKHKP9/heylloyd-image-1769473134106.png" alt="Regalo Gratis - Guía Completa de Implementación" className="w-full max-w-3xl mx-auto rounded-lg border border-[#00f7fc]/50 group-hover:border-[#00f7fc] group-hover:scale-[1.01] transition-all duration-300 cursor-pointer shadow-xl" data-id="element-3853" />
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-black/10 rounded-lg" data-id="element-3854">
                  <div className="bg-[#00f7fc]/95 backdrop-blur-sm text-black px-5 py-2.5 rounded-full font-semibold text-base shadow-lg" data-id="element-3855">
                    Descargar guía
                  </div>
                </div>
              </div>
            </a>
          </div>

          <p className="text-center text-base md:text-lg leading-normal px-4 text-gray-100" data-id="element-3856">
            Antes del workshop, quiero que descargues esta guía y la leas con
            calma.
            <br data-id="element-3857" />
            <br data-id="element-3858" />
            Esta guía no es un regalo más. No es un PDF para ejecutar. Y no es
            algo para "aplicar" todavía.
            <br data-id="element-3859" />
            <br data-id="element-3860" />
            Su único objetivo es ayudarte a llegar al workshop con el marco
            mental correcto.
            <br data-id="element-3861" />
            <br data-id="element-3862" />
            La mayoría de las personas se equivoca antes de empezar—no porque no
            sepa qué hacer, sino porque empieza por el lugar incorrecto.
            <br data-id="element-3863" />
            <br data-id="element-3864" />
            Esta guía te ayudará a entender el orden correcto para que el
            contenido del workshop tenga sentido desde el primer minuto.
          </p>
        </div>

        {/* Step 3: Check Email */}
        <div className="mb-10 md:mb-14 max-w-3xl mx-auto" data-id="element-3865">
          <div className="bg-gray-800/50 border border-gray-700 rounded-xl p-5 md:p-6" data-id="element-3866">
            <div className="flex items-center gap-3 mb-3" data-id="element-3867">
              <div className="bg-yellow-500/20 p-2.5 rounded-full" data-id="element-3868">
                <Mail className="w-6 h-6 text-yellow-500" data-id="element-3869" />
              </div>
              <h3 className="text-lg md:text-xl font-bold tracking-tight" data-id="element-3870">
                Paso #3: Revisa Tu Email
              </h3>
            </div>
            <p className="text-base text-gray-300" data-id="element-3871">
              Revisa tu bandeja de entrada (y spam) para confirmar tu acceso al
              evento.
            </p>
          </div>
        </div>

        {/* BREAKOUT VIDEOS SECTION */}
        <div className="mb-10 md:mb-14 max-w-5xl mx-auto" data-id="element-3872">
          <div className="text-center mb-8" data-id="element-3873">
            <h2 className="text-2xl md:text-3xl font-black mb-3" data-id="element-3874">
              ¿Tienes Dudas?{' '}
              <span className="text-[#00f7fc]" data-id="element-3875">Las Resolvemos Aquí:</span>
            </h2>
            <p className="text-gray-400 text-base" data-id="element-3876">
              Mira estos videos cortos para resolver las preguntas más comunes.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-3877">
            {/* Video 1 */}
            <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden flex flex-col" data-id="element-3878">
              <div className="bg-gray-800 relative" data-id="element-3879">
                <div style={{
                padding: '56.25% 0 0 0',
                position: 'relative'
              }} data-id="element-3880">
                  <iframe src="https://player.vimeo.com/video/1173156247?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="BREAKOUT VID 1" data-id="element-3881"></iframe>
                </div>
              </div>
              <div className="p-4 flex-1" data-id="element-3882">
                <p className="font-bold text-sm" data-id="element-3883">
                  ¿Y si HEYLLOYD no funciona para mi nicho o tipo de negocio?
                </p>
              </div>
            </div>

            {/* Video 2 */}
            <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden flex flex-col" data-id="element-3884">
              <div className="bg-gray-800 relative" data-id="element-3885">
                <div style={{
                padding: '56.25% 0 0 0',
                position: 'relative'
              }} data-id="element-3886">
                  <iframe src="https://player.vimeo.com/video/1173156261?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="BREAKOUT VID 2" data-id="element-3887"></iframe>
                </div>
              </div>
              <div className="p-4 flex-1" data-id="element-3888">
                <p className="font-bold text-sm" data-id="element-3889">
                  Ya he invertido en otros programas y no me funcionaron. ¿Qué
                  hace a este diferente?
                </p>
              </div>
            </div>

            {/* Video 3 */}
            <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden flex flex-col" data-id="element-3890">
              <div className="bg-gray-800 relative" data-id="element-3891">
                <div style={{
                padding: '56.25% 0 0 0',
                position: 'relative'
              }} data-id="element-3892">
                  <iframe src="https://player.vimeo.com/video/1173156277?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="BREAKOUT VIDEO 3" data-id="element-3893"></iframe>
                </div>
              </div>
              <div className="p-4 flex-1" data-id="element-3894">
                <p className="font-bold text-sm" data-id="element-3895">
                  No tengo tiempo para implementar otro sistema complejo.
                </p>
              </div>
            </div>

            {/* Video 4 */}
            <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden flex flex-col" data-id="element-3896">
              <div className="bg-gray-800 relative" data-id="element-3897">
                <div style={{
                padding: '56.25% 0 0 0',
                position: 'relative'
              }} data-id="element-3898">
                  <iframe src="https://player.vimeo.com/video/1173156217?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="BREAKOUT VID 4" data-id="element-3899"></iframe>
                </div>
              </div>
              <div className="p-4 flex-1" data-id="element-3900">
                <p className="font-bold text-sm" data-id="element-3901">
                  Me preocupa el costo de la inversión. ¿Cuál es el ROI real?
                </p>
              </div>
            </div>

            {/* Video 5 */}
            <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden flex flex-col" data-id="element-3902">
              <div className="bg-gray-800 relative" data-id="element-3903">
                <div style={{
                padding: '56.25% 0 0 0',
                position: 'relative'
              }} data-id="element-3904">
                  <iframe src="https://player.vimeo.com/video/1173156206?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="BREAKOUT VID 5" data-id="element-3905"></iframe>
                </div>
              </div>
              <div className="p-4 flex-1" data-id="element-3906">
                <p className="font-bold text-sm" data-id="element-3907">
                  ¿No puedo simplemente hacer lo mismo con ChatGPT y otras
                  herramientas gratuitas?
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <Footer data-id="element-3908" />

      {/* Terms Modal */}
      {showTerms && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowTerms(false)} data-id="element-3909">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative" onClick={e => e.stopPropagation()} data-id="element-3910">
            <button onClick={() => setShowTerms(false)} className="absolute top-4 right-4 text-gray-300 hover:text-white transition-colors" data-id="element-3911">
              <X className="w-6 h-6" data-id="element-3912" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-3913">
              Términos y Condiciones
            </h2>
            <div className="text-gray-200 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-3914">
              <p data-id="element-3915">
                Al registrarte y participar en el 48 Hrs AI Cash Machine
                Masterclass, aceptas los siguientes términos y condiciones:
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3916">
                1. Aceptación de Términos
              </h3>
              <p data-id="element-3917">
                Al acceder y utilizar este sitio web y registrarte para el
                evento, aceptas estar sujeto a estos términos y condiciones,
                todas las leyes y regulaciones aplicables.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3918">
                2. Uso del Servicio
              </h3>
              <p data-id="element-3919">
                El contenido proporcionado en el masterclass es solo para fines
                educativos e informativos. No garantizamos resultados
                específicos de ingresos o éxito comercial.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3920">
                3. Propiedad Intelectual
              </h3>
              <p data-id="element-3921">
                Todo el contenido, materiales, y recursos proporcionados son
                propiedad de 48 Hrs AI Cash Machine y están protegidos por
                derechos de autor.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3922">
                4. Limitación de Responsabilidad
              </h3>
              <p data-id="element-3923">
                48 Hrs AI Cash Machine no será responsable de ningún daño
                directo, indirecto, incidental o consecuente que resulte del uso
                o la imposibilidad de usar nuestros servicios.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3924">
                5. Modificaciones
              </h3>
              <p data-id="element-3925">
                Nos reservamos el derecho de modificar estos términos en
                cualquier momento.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3926">Contacto</h3>
              <p data-id="element-3927">
                Para preguntas sobre estos términos, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-[#00f7fc] hover:text-[#00d7dc]" data-id="element-3928">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}

      {/* Privacy Modal */}
      {showPrivacy && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowPrivacy(false)} data-id="element-3929">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative" onClick={e => e.stopPropagation()} data-id="element-3930">
            <button onClick={() => setShowPrivacy(false)} className="absolute top-4 right-4 text-gray-300 hover:text-white transition-colors" data-id="element-3931">
              <X className="w-6 h-6" data-id="element-3932" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-3933">
              Política de Privacidad
            </h2>
            <div className="text-gray-200 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-3934">
              <p data-id="element-3935">
                En 48 Hrs AI Cash Machine, nos comprometemos a proteger tu
                privacidad.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3936">
                1. Información que Recopilamos
              </h3>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-3937">
                <li data-id="element-3938">Nombre y dirección de correo electrónico</li>
                <li data-id="element-3939">Información de registro del evento</li>
                <li data-id="element-3940">Comunicaciones que mantienes con nosotros</li>
              </ul>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3941">
                2. Uso de la Información
              </h3>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-3942">
                <li data-id="element-3943">
                  Proporcionar acceso al masterclass y materiales relacionados
                </li>
                <li data-id="element-3944">Enviar comunicaciones sobre el evento</li>
                <li data-id="element-3945">Mejorar nuestros servicios y contenido</li>
                <li data-id="element-3946">Cumplir con obligaciones legales</li>
              </ul>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3947">
                3. Compartir Información
              </h3>
              <p data-id="element-3948">
                No se compartirá información móvil con terceros ni afiliados con
                fines de marketing ni promocionales.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3949">
                4. Seguridad de Datos
              </h3>
              <p data-id="element-3950">
                Implementamos medidas de seguridad técnicas y organizativas
                apropiadas para proteger tu información personal.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3951">
                5. Tus Derechos
              </h3>
              <p data-id="element-3952">
                Tienes derecho a acceder, corregir o eliminar tu información
                personal. Contáctanos en:{' '}
                <a href="mailto:support@truemarketer.com" className="text-[#00f7fc] hover:text-[#00d7dc]" data-id="element-3953">
                  support@truemarketer.com
                </a>
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3954">6. Cookies</h3>
              <p data-id="element-3955">
                Utilizamos cookies y tecnologías similares para mejorar tu
                experiencia en nuestro sitio web.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-3956">Contacto</h3>
              <p data-id="element-3957">
                Para preguntas:{' '}
                <a href="mailto:support@truemarketer.com" className="text-[#00f7fc] hover:text-[#00d7dc]" data-id="element-3958">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}

      {/* Floating WhatsApp Button */}
      <WhatsAppButton data-id="element-3959" />
    </div>;
}